import { createPropertySchema } from "./create-property.js";
export const updatePropertySchema = createPropertySchema.partial();
